import placeholder from '../assets/images/members_photos/placeholder.png'


const TeamListData = [
    {
        title: 'board',
        members: [
            {
                name: 'João Fernandes', role: 'team-leader', imageSrc: placeholder
            },
            {
                name: 'Guilherme Costa', role: 'technical-director', imageSrc: placeholder
            },
        ],
    },
    /* ///////Techincal//////// */
    {
        title: 'aerodynamics',
        members: [
            {
                name: 'Francisco Rodrigues', role: 'dep-leader', imageSrc: placeholder
            },
            {
                name: 'Beatriz Simões', role: 'member', imageSrc: placeholder
            },
            {
                name: 'Rafael Nunes', role: 'member', imageSrc: placeholder
            },
            {
                name: 'Ricardo Cutileiro', role: 'member', imageSrc: placeholder
            },

        ],
    },
    {
        title: 'chassis&Dynamics',
        members: [
            {
                name: 'João Fernandes', role: 'dep-leader', imageSrc: placeholder
            },
            {
                name: 'António Figueiredo', role: 'member', imageSrc: placeholder
            },
            {
                name: 'Hugo Grilo', role: 'member', imageSrc: placeholder
            },
            {
                name: 'João Balbino', role: 'member', imageSrc: placeholder
            },

        ],
    },
    {
        title: 'electronics',
        members: [
            {
                name: 'Frederico Inácio', role: 'dep-leader', imageSrc: placeholder
            },
            {
                name: 'Sergiu Nica', role: 'member', imageSrc: placeholder
            },
            {
                name: 'Daniel Sousa', role: 'member', imageSrc: placeholder
            },
            {
                name: 'Gustavo Raio', role: 'member', imageSrc: placeholder
            },
            {
                name: 'Jorge Ferreira', role: 'member', imageSrc: placeholder
            },
            {
                name: 'Ruben Vaz', role: 'member', imageSrc: placeholder
            },
            {
                name: 'Tiago Mega', role: 'member', imageSrc: placeholder
            },

        ],
    },
    {
        title: 'powertrain',
        members: [
            {
                name: 'António Ferreira', role: 'dep-leader', imageSrc: placeholder
            },
            {
                name: 'Gonçalo Correia', role: 'member', imageSrc: placeholder
            },
            {
                name: 'Fabio Santos', role: 'member', imageSrc: placeholder
            },
            {
                name: 'João Botelho', role: 'member', imageSrc: placeholder
            },

        ],
    },
    /* ///////BS//////// */
    {
        title: 'marketing',
        members: [
            {
                name: 'Isabel Botelho', role: 'dep-leader', imageSrc: placeholder
            },
            {
                name: 'Pedro Botelho', role: 'member', imageSrc: placeholder
            },
            {
                name: 'Tiago Soares', role: 'member', imageSrc: placeholder
            },
            {
                name: 'Mafalda Pinto', role: 'member', imageSrc: placeholder
            },
            {
                name: 'José Lima', role: 'member', imageSrc: placeholder
            },
            {
                name: 'Rodrigo Alegria', role: 'member', imageSrc: placeholder
            },
            {
                name: 'Bernardo Santos', role: 'member', imageSrc: placeholder
            },
            {
                name: 'Pedro Trindade', role: 'member', imageSrc: placeholder
            },
            {
                name: 'João Domingues', role: 'member', imageSrc: placeholder
            },
        ],
    },
    {
        title: 'corporate-relations',
        members: [
            {
                name: 'Isabel Botelho', role: 'dep-leader', imageSrc: placeholder
            },
            {
                name: 'Pedro Botelho', role: 'member', imageSrc: placeholder
            },
            {
                name: 'Tiago Soares', role: 'member', imageSrc: placeholder
            },
            {
                name: 'Mafalda Pinto', role: 'member', imageSrc: placeholder
            },
            {
                name: 'José Lima', role: 'member', imageSrc: placeholder
            },
            {
                name: 'Rodrigo Alegria', role: 'member', imageSrc: placeholder
            },
            {
                name: 'Bernardo Santos', role: 'member', imageSrc: placeholder
            },
            {
                name: 'Pedro Trindade', role: 'member', imageSrc: placeholder
            },
            {
                name: 'João Domingues', role: 'member', imageSrc: placeholder
            },
        ],
    },


];

export default TeamListData;